import { ChangeDetectionStrategy, Component, Input } from '@angular/core';

import { IUserData, UserInitialsPipe } from '@resident-nx/shared';

export enum AvatarSizeEnum {
  TINY = 'tiny',
  SMALL = 'small',
  MEDIUM = 'medium',
  LARGE = 'large',
  MAX = 'max',
}

@Component({
  standalone: true,
  selector: 'rs-web-avatar',
  templateUrl: './avatar.component.html',
  styleUrl: './avatar.component.css',
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [UserInitialsPipe],
})
export class AvatarWebComponent {
  @Input() userData: IUserData;
  @Input() size = AvatarSizeEnum.MAX;
  @Input() rounded = false;
  public avatarSizeEnum = AvatarSizeEnum;
}
